import { gql } from 'apollo-angular';
import { notificationItemFragment } from './notification.fragments';

export const NotificationsQuery = gql`
  query NotificationsQuery($source: [NotificationSourceEnum!]) {
    notifications(source: $source) {
      nodes {
        ... on Notification {
          ...NotificationItem
        }
      }
    }
  }
  ${notificationItemFragment}
`;

export const MarkAllAsReadMutation = gql`
  mutation MarkAllAsReadMuation($input: MarkAllNotificationsAsReadInput!) {
    markAllNotificationsAsRead(input: $input) {
      clientMutationId
      notifications {
        ...NotificationItem
      }
    }
  }
  ${notificationItemFragment}
`;

export const DestroyNotificationMutation = gql`
  mutation DestroyNotificationMutation($input: DestroyNotificationInput!) {
    destroyNotification(input: $input) {
      errors {
        message
        path
      }
      notification {
        id
      }
    }
  }
`;

export const UpdateNotificationMutation = gql`
  mutation UpdateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      clientMutationId
      errors {
        message
        path
      }
      notification {
        ...NotificationItem
      }
    }
  }
  ${notificationItemFragment}
`;
